var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "main-screen",
    style: {
      backgroundImage: _vm.backgroundImage
    }
  }, [_c('div', {
    staticClass: "main-screen-container"
  }, [_c('div', {
    staticClass: "title-container"
  }, [_c('capusta-title', {
    attrs: {
      "title": _vm.$t('timezone.title'),
      "icon-outside": ""
    }
  }, [_c('template', {
    slot: "description"
  }, [_c('div', {
    staticClass: "main-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('timezone.description'))
    }
  })])], 2)], 1), _c('div', {
    staticClass: "content-container"
  }, [_c('substrate-mount', [_c('simple-button', {
    attrs: {
      "size": "small",
      "variant": "darken"
    },
    on: {
      "click": _vm.handleShownTimezoneAutomaticDetection
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('timezone.automatic.detection.button')) + " ")]), _c('div', {
    staticClass: "option-container"
  }, [_c('option-panel', {
    attrs: {
      "option": _vm.formattedTimezoneArea,
      "noactive": ""
    },
    on: {
      "click": _vm.handleShownTimezoneAreaList
    }
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])], 1)], 1), _c('div', {
    staticClass: "option-container"
  }, [_c('option-panel', {
    attrs: {
      "option": _vm.formattedTimeToUTCWithCity,
      "noactive": ""
    },
    on: {
      "click": _vm.handleShownCurrentAreaTimezoneList
    }
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])], 1)], 1), _c('div', {
    staticClass: "text-container"
  }, [_vm._v(" " + _vm._s(_vm.formattedDateTimeWithTimezone) + " ")])], 1)], 1)])]), _c('timezone-area-dialog', {
    on: {
      "change": _vm.updateMerchantTimezone
    }
  }), _c('timezone-zones-dialog', {
    on: {
      "change": _vm.updateMerchantTimezone
    }
  }), _c('timezone-automatic-detection-dialog', {
    on: {
      "change": _vm.updateMerchantTimezone
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }